import React from "react";
import InfoGridList from "./infoGridList";
import _ from "lodash";
import { Avatar, Group, Text } from "@mantine/core";
import { IconBox } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import EntityTabAnchor, {
  ENTITY_TAB_ANCHOR_PLAIN_SX,
} from "../pages/account/payroll2/EntityTabAnchor";

const OrderProductDetail = ({ form, name }) => {
  const { t } = useTranslation();
  const order = name ? _.get(form.values, name) : form.values;
  const product = order?.product;
  const provider = order?.provider ?? product?.provider;
  const providerId = provider?._id ?? provider;
  const productCategory =
    order?.productCategory ?? product?.category ?? product?.type?.category;
  const productType = order?.productType ?? product?.type;

  const bizLine = productCategory ? (
    <div>
      <Text lineClamp={1}>{productCategory.name}</Text>
      {productCategory.cname && (
        <Text color="dimmed" lineClamp={1} size="xs">
          {productCategory.cname}
        </Text>
      )}
    </div>
  ) : (
    "-"
  );

  const classCol = productType ? (
    <div>
      <Text lineClamp={1}>{productType.name}</Text>
      {productType.cname && (
        <Text color="dimmed" lineClamp={1} size="xs">
          {productType.cname}
        </Text>
      )}
    </div>
  ) : (
    "-"
  );

  const insurer = provider ? (
    <Group noWrap align="center" spacing="sm">
      <Avatar
        src={
          provider.image
            ? `${process.env.REACT_APP_FILE_URL}/${provider.image}`
            : null
        }
        radius="xl"
        size="md"
      >
        {!provider?.image && <IconBox size="1rem" />}
      </Avatar>
      <EntityTabAnchor
        entity="provider"
        id={providerId}
        label={provider.name}
        fallback={provider.name ?? "-"}
        size="sm"
        weight={600}
        underline={false}
        sx={ENTITY_TAB_ANCHOR_PLAIN_SX}
      />
    </Group>
  ) : (
    "-"
  );

  const productCol = product ? (
    <div>
      <EntityTabAnchor
        entity="product"
        id={product._id}
        label={product.name}
        fallback={product.name ?? "-"}
        size="sm"
        weight={600}
        underline={false}
        sx={ENTITY_TAB_ANCHOR_PLAIN_SX}
      />
      {product.cname && (
        <Text lineClamp={1} size="xs">
          {product.cname}
        </Text>
      )}
      {product.code && (
        <Text color="dimmed" lineClamp={1} size="xs">
          {product.code}
        </Text>
      )}
    </div>
  ) : (
    "-"
  );

  const fields = [
    {
      title: "orderFilter.bizLine",
      value: bizLine,
    },
    {
      title: "Class",
      value: classCol,
    },
    {
      title: "Insurer",
      value: insurer,
    },
    {
      title: "Product",
      value: productCol,
      colSpan: 3,
    },
  ];

  if (order?.mpfAccountType) {
    fields.push({
      title: "MPF Account Type",
      value: t(order.mpfAccountType),
      colSpan: 3,
    });
  }

  return (
    order && (
      <InfoGridList
        fields={fields}
        values={order}
        cols={3}
        dataFontWeight={600}
      />
    )
  );
};

export default OrderProductDetail;
